
<template>
  <el-form-item :label="params.label" class="watsonDaterange" style="25.875rem;">
    <el-date-picker
      v-if="showTimeRange"
      class="w350"
      size="small"
      popper-class="customs_datetimerange_picker"
      v-model="dataRange"
      type="datetimerange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @focus="focus"
      @blur="blur"
      :default-time="defaultTime">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { dateFormat } from '@/utils/tools'
export default {
  name: 'form-dataRange',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      showTimeRange: true,
      dataRange: this.params.start && this.params.end ? [new Date(this.params.start), new Date(this.params.end)] : null,
      defaultTime: [dateFormat(new Date(), 'hh:mm:ss'), dateFormat(new Date(), 'hh:mm:ss')]
    }
  },
  created() {},
  methods: {
    focus() {
      this.defaultTime = [dateFormat(new Date(), 'hh:mm:ss'), dateFormat(new Date(), 'hh:mm:ss')]
    },
    blur() {
      const vm = this
      vm.showTimeRange = false
      setTimeout(() => {
        vm.showTimeRange = true
      }, 30)
    },
    reset() {
      if (this.params.dValue) {
        this.dataRange = this.params.dValue
      } else {
        this.dataRange = undefined
      }
    },
    getValue() {
      if (this.dataRange && this.dataRange.length) {
        if (this.params.key !== 'time') {
          return {
            [this.params.key + 'StartTime']: dateFormat(this.dataRange[0], 'yyyy-MM-dd hh:mm:ss'),
            [this.params.key + 'EndTime']: dateFormat(this.dataRange[1], 'yyyy-MM-dd hh:mm:ss')
          }
        } else {
          return {
            startTime: dateFormat(this.dataRange[0], 'yyyy-MM-dd hh:mm:ss'),
            endTime: dateFormat(this.dataRange[1], 'yyyy-MM-dd hh:mm:ss')
          }
        }
      }
      return undefined
    }
  },
  watch: {
    dataRange(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      if (nv) {
        cp.start = dateFormat(nv[0], 'yyyy-MM-dd hh:mm:ss')
        cp.end = dateFormat(nv[1], 'yyyy-MM-dd hh:mm:ss')
      } else {
        cp.start = undefined
        cp.end = undefined
      }
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less">
@import "../miBicycle.less";
.customs_datetimerange_picker {
  width: 17%;
  /* 隐藏右边日期面板 */
  .el-picker-panel__content.el-date-range-picker__content.is-right .el-date-table,
  .el-picker-panel__content.el-date-range-picker__content.is-right
  .el-date-range-picker__header
  div {
    display: none !important;
    height: 800px;
  }
  .el-picker-panel__content.el-date-range-picker__content.is-right
  .el-date-range-picker__header {
    width: 60px;
    top: -331px;
    left: 230px;
  }
  /* 设置整体日期面板的宽度 */
  .el-picker-panel.el-date-range-picker.el-popper {
    width: 322px;
  }

  /* 隐藏中间线段 */
  .el-date-range-picker__content.is-left {
    border-right: none;
  }

  /* 左边日期面板宽度 */
  .el-picker-panel__content {
    width: 63% !important;
  }
  .el-picker-panel__content.el-date-range-picker__content.is-right .el-date-range-picker__header {
    top: -281px;
  }
  .el-date-range-picker__content.is-left {
    height: 270px;
  }
  .el-date-range-picker__time-picker-wrap:first-child {
    display: none !important;
  }
  .el-date-range-picker__time-header {
    width: 62%;
  }
}
</style>
